import { buildSettingHeaderKey } from "@faire/next-utils/middleware/headers/utils";
import { PERF_DARK_READ_TESTING } from "@faire/web-api--source/indigofair/settings/PERF_DARK_READ_TESTING";
import { PERF_DARK_READ_TESTING_OVERRIDE_LOCALE_HEADER } from "@faire/web-api--source/indigofair/settings/PERF_DARK_READ_TESTING_OVERRIDE_LOCALE_HEADER";

// Standard headers
export const HEADER_COOKIE = "Cookie";
export const HEADER_CONTENT_TYPE = "Content-Type";
export const HEADER_REFERER = "Referer";
export const HEADER_USER_AGENT = "User-Agent";
export const HEADER_CLIENT_IP = "X-Forwarded-For";
export const HEADER_SET_COOKIE = "Set-Cookie";
export const HEADER_ACCEPT = "Accept";

// Security headers
export const HEADER_HACKERONE_USERNAME = "X-Hackerone-Research";
export const HEADER_FLAG_MFA = "X-Faire-Sec-Flag-Mfa";
export const HEADER_BOT_SCORE = "X-Faire-Sec-Bot-Score";
export const HEADER_VERIFIED_BOT = "X-Faire-Sec-Bot-Verified-Bot";
export const HEADER_JA3_FINGERPRINT = "X-Faire-Sec-Ja3-Fingerprint";
export const HEADER_JA4_FINGERPRINT = "X-Faire-Sec-Ja4-Fingerprint";
export const HEADER_CLOUDFLARE_THREAT_SCORE = "X-Faire-Sec-Cf-Threat-Score";
export const HEADER_CLOUDFLARE_EDGE_RAY_ID = "X-Faire-Edge-Ray-Id";
export const HEADER_CLOUDFLARE_JS_DETECTION_PASSED =
  "X-Faire-Sec-Js-Detection-Passed";
export const HEADER_CONTENT_SECURITY_POLICY_REPORT_ONLY =
  "Content-Security-Policy-Report-Only";
export const HEADER_CONTENT_SECURITY_POLICY = "Content-Security-Policy";

// Internal Headers
export const HEADER_TIMEZONE = "X-Faire-Timezone";
export const HEADER_IS_DEVELOPMENT = "X-If-Development";
export const HEADER_PERF_DARK_READ = "X-Faire-Perf-Dark";
export const HEADER_FORWARDED_PATH = "X-Forwarded-Path";
export const HEADER_HCAPTCHA_TOKEN = "X-If-Hcaptcha-Token";
export const HEADER_GEOIP_COUNTRY_ISO = "X-If-Geoip-Country-Iso";
export const HEADER_ACCEPT_CURRENCY = "X-If-Accept-Currency";
export const HEADER_IS_SYNTHETIC_REQUEST = "X-If-Is-Synthetic-Request";
export const HEADER_IS_E2E_REQUEST = "X-If-Is-E2E-Request";
export const HEADER_BRAND_PREVIEW = "X-If-Brand-Preview";
export const HEADER_E2E_TEST_TOKEN = "X-E2e-Test-Token";
export const HEADER_BROWSER_TAB_ID = "X-Faire-Browser-Tab-Id";
export const HEADER_IS_APPAREL_RETAILER = "X-Is-Apparel";
// Response header that is set when the cache is hit during an S2S request.
export const HEADER_NEXT_API_CACHE_HIT = "X-If-Next-Api-Cache-Hit";
// Request header set by the extension to mock responses for S2S requests
export const HEADER_MOCK_S2S_RESPONSES = "X-If-Mock-S2s-Responses";
export const HEADER_MIDDLEWARE_REWRITE_PREFIX =
  "X-If-Middleware-Rewrite-Prefix";

// These headers contain dark read configs and are passed by middleware
export const HEADER_PERF_DARK_READ_TESTING_CONFIG = buildSettingHeaderKey(
  PERF_DARK_READ_TESTING
);
export const HEADER_PERF_DARK_READ_TESTING_LOCALE_CONFIG =
  buildSettingHeaderKey(PERF_DARK_READ_TESTING_OVERRIDE_LOCALE_HEADER);

// Tracing headers
export const HEADER_REQUEST_ID = "X-Request-Id";
export const HEADER_TRACE_STATE = "Tracestate";
export const HEADER_TRACE_PARENT = "Traceparent";
export const HEADER_ROOT_OPERATION_ID_KEY = "Rop";
export const HEADER_ROOT_OPERATION_TYPE_KEY = "Ropt";
export const HEADER_TRANSACTION_ID_KEY = "Tx";
export const HEADER_JOB_CLASS_NAME_KEY = "Job";
export const HEADER_TASK_CLASS_NAME_KEY = "Task";
export const HEADER_PARENT_OPERATION_ID_KEY = "Pop";
export const HEADER_PARENT_OPERATION_TYPE_KEY = "Popt";
export const HEADER_OPERATION_ID_KEY = "Op";
export const HEADER_OPERATION_TYPE_KEY = "Opt";

export const HEADER_B3_SAMPLED = "X-B3-Sampled";
export const HEADER_B3_FLAGS = "X-B3-Flags";
export const HEADER_LOCATION = "X-Pathname";

// Sent to backend, indicating that the request is just for head tags
export const USE_HEAD_TAGS_DATA_HEADER = "X-IF-HEAD-TAGS-DATA";

// web-api headers
export const HEADER_VIA = "Via";

// Cloudflare headers
export const HEADER_CLOUDFLARE_RAY_ID = "Cf-Ray";
